var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 28,
    viewBox: "0 0 37 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83398 27.3332C2.1951 27.3332 1.61871 27.0762 1.10482 26.5623C0.590929 26.0484 0.333984 25.4721 0.333984 24.8332V3.1665C0.333984 2.52761 0.590929 1.95123 1.10482 1.43734C1.61871 0.923448 2.1951 0.666504 2.83398 0.666504H14.5423L17.0423 3.1665H31.1673C31.8062 3.1665 32.3826 3.42345 32.8965 3.93734C33.4104 4.45123 33.6673 5.02761 33.6673 5.6665H2.83398V24.8332L7.08398 8.1665H36.1673L31.709 25.4165C31.5423 26.0832 31.2368 26.5693 30.7923 26.8748C30.3479 27.1804 29.7784 27.3332 29.084 27.3332H2.83398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFolder);
export default __webpack_public_path__ + "static/media/openFolder.36b03faa14e4c39208bfb49d82bfdbd4.svg";
export { ForwardRef as ReactComponent };